<div
  class="container d-flex justify-content-center align-items-center"
  style="height: 100vh; padding: 0 16px"
>
  <div class="row" style="width: 100%; display: flex; justify-content: center">
    <!-- Success Message -->
    <mat-card
      *ngIf="paymentStatus === true"
      style="max-width: 400px; width: 100%; padding: 24px"
    >
      <div
        style="
          text-align: center;
          font-size: 1.75rem;
          font-weight: 600;
          color: #2e7d32;
        "
      >
        ✅ Payment Successful
      </div>

      <div
        style="
          text-align: center;
          margin-top: 16px;
          font-size: 1rem;
          color: #444;
        "
      >
        Thank you! Your payment has been successfully processed.<br /><br />
        <!-- A detailed invoice has been sent to your registered email address.<br /><br /> -->
        For support or billing inquiries, feel free to reach out:<br />
        <a href="mailto:help@gymbook.in" target="_top">help@gymbook.in</a>
      </div>
    </mat-card>

    <!-- Failure Message -->
    <mat-card
      *ngIf="paymentStatus === false"
      style="max-width: 400px; width: 100%; padding: 24px"
    >
      <div
        style="
          text-align: center;
          font-size: 1.75rem;
          font-weight: 600;
          color: #c62828;
        "
      >
        ❌ Payment Failed
      </div>

      <div
        style="
          text-align: center;
          margin-top: 16px;
          font-size: 1rem;
          color: #444;
        "
      >
        Unfortunately, your payment could not be completed.<br /><br />
        If an amount was deducted from your account, please email us with the
        transaction details.<br /><br />
        Contact support at: <br />
        <a href="mailto:help@gymbook.in" target="_top">help@gymbook.in</a>
      </div>
    </mat-card>
  </div>
</div>
